<template>
  <!-- 用户信息 -->
  <div>
    <el-card>
      <div class="operation">
        <el-input class="ipt" v-model="mobile" placeholder="请输入要查找的手机号" clearable></el-input>
        <el-button type="success" @click="getUserList">查询</el-button>

      </div>
      <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
        >
   
        <el-table-column prop="id" label="序号" min-width align="center"></el-table-column>
        <el-table-column prop="nickName" label="昵称" min-width></el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width></el-table-column>

        <el-table-column label="头像" min-width>
          <template slot-scope="scope">
           
            <img :src="computeUrl(scope.row.avatar)" style="width: 80px; height: 80px; margin: center " />
          </template>
        </el-table-column>


        <el-table-column prop="useTimes" label="使用次数" min-width></el-table-column>

        <el-table-column prop="createDate" label="注册时间" min-width></el-table-column>

        <el-table-column label="查看" width="200">
          <template slot-scope="scope">

            <el-button type="primary" @click="addBabyInfo(scope.row.babyEntityList)" size="small">宝宝信息</el-button>
            <el-button type="primary" @click="addSoundRecordInfo(scope.row.mobile)" size="small">测量数据</el-button>
          </template>
        </el-table-column>

   
      </el-table>

      <div class="page">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currPage"
          :page-sizes="[5, 10, 15, 20]" :page-size="totalSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total"></el-pagination>
      </div>



      <!-- 弹出宝宝具体信息 -->
      <el-dialog :visible.sync="addBabyVisible" width="40%" title="宝宝信息" @close="CloseBabyVisible">
        <div style="height:500px;text-align:center">

          <!--需要弹出的内容部分-->

          <el-table border :data="babyData">
            <template v-for="item in babyData" v-bind:item="item">

            </template>

            <el-table-column prop="nickName" label="昵称" min-width></el-table-column>

            <el-table-column label="头像" min-width>

              <template slot-scope="scope">
                <div>
                  <!-- <img :src="scope.row.avatar" /> -->
                  <img :src="'data:image/png;base64,' + scope.row.avatar"
                    style="width: 80px; height: 80px; margin: center" />
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="expectedDate" label="预产期" align="center" min-width="160"></el-table-column>

            <el-table-column prop="status" label="状态" min-width :formatter="Formatter"></el-table-column>

            <el-table-column prop="createDate" label="注册时间" align="center" min-width="160"></el-table-column>

          </el-table>


        </div>
      </el-dialog>



      <!-- 弹出测量数据具体信息 -->
      <el-dialog :visible.sync="addSoundRecordVisible" width="60%" title="测量信息" @close="CloseSoundRecordVisible">
        <div style="height:500px;text-align:center">

          <!--需要弹出的内容部分-->

          <el-table border :data="soundRecordData">
            <template v-for="item in soundRecordData" v-bind:item="item">

            </template>
            <el-table-column label="序号" width="50" align="center">
    <template slot-scope="scope">{{scope.$index+1}}</template>
</el-table-column>

            <el-table-column prop="measuringTime" label="测量时间" align="center" min-width="160"></el-table-column>

            <el-table-column prop="measuringDuration" label="测量时长/秒" align="center" min-width="100" ></el-table-column>

            <el-table-column prop="heartHigh" label="心率/高" align="center" min-width="80"></el-table-column>

            <el-table-column prop="heartLow" label="心率/低" align="center" min-width="80"></el-table-column>

            <el-table-column prop="shareFlag" label="分享状态" align="center" min-width="80" :formatter="formatterShareFlag"></el-table-column>

            <el-table-column prop="delFlag" label="删除状态" align="center" min-width="80" :formatter="formatterDelFlag"></el-table-column>

            <el-table-column prop="realUrl" label="录音地址" align="center" min-width="160" show-overflow-tooltip></el-table-column>

          </el-table>


        </div>


        <div class="page">
        <el-pagination @size-change="handleSoundSizeChange" @current-change="handleSoundCurrentChange" :current-page="cPage"
          :page-sizes="[5, 10, 15, 20]" :page-size="tSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNumber"></el-pagination>
      </div>


      </el-dialog>



 
    </el-card>
  </div>
</template>
<script>

export default {
  data() {
    return {
      // 查询参数
      // gradeId: "",
      mobile: "",
      username: "",
 
      addBabyVisible: false,
      addSoundRecordVisible: false,
      total: 0,
      currPage: 1,
      totalSize: 10,

      totalNumber: 0,
      cPage: 1,
      tSize: 10,

      // 所有用户列表数据
      tableData: [],
      babyData: [],
      soundRecordData:[],
 
  
      // 选中的项目id
      checkUserid: [],
      checkPro: "",
    };


  },

  computed: {
    computeUrl() {
      return function (val) {

        if (val) {
          if (val.includes("http")) {
            return val
          } else {
            return 'data:image/png;base64,' + val
          }
        }
        else {
          return val
        }

      }

    }
  },


  created() {
    this.getUserList();
  },
  methods: {

    // 点击新增弹框(宝宝信息)
    addBabyInfo(babyEntityList) {
      this.addBabyVisible = true;
      this.babyData = babyEntityList;
     
    },

    // 点击新增弹框(测量数据)
    async addSoundRecordInfo(mobile) {
   
      this.addSoundRecordVisible = true;

      this.mobile = mobile;
      const { data: res } = await this.$http.post("/sys/sound/record/recordList", {
        
        mobile: mobile,
        totalSize: this.tSize,
        currPage: this.cPage,
      });
      
      if (res.code != "000000") {
        this.$message.error("测量信息请求失败");
      } else {
        this.soundRecordData = res.data.records;
        this.totalNumber = res.data.total;
      }
      
    },


    
    CloseBabyVisible() {
      this.addBabyVisible = false;
    },

    CloseSoundRecordVisible() {
      this.mobile = '';
      this.addSoundRecordVisible = false;
    },

    // 获取列表
    async getUserList() {
      const { data: res } = await this.$http.post("sys/user/list", {
        // username: this.username,
        mobile: this.mobile,
        totalSize: this.totalSize,
        currPage: this.currPage,
      });
      console.log(res)
      if (res.code != "000000") {
        this.$message.error("用户信息请求失败");
      } else {
        this.tableData = res.data.records;
        this.total = res.data.total;

      }
    },

    // 每页显示条数变化
    handleSizeChange(newSize) {
      this.totalSize = newSize;
      this.getUserList();
    },
    // 当前页变化
    handleCurrentChange(newPage) {
      this.currPage = newPage;
      this.getUserList();
    },

    Formatter(row) {
      if (row.status == 0) {
        return "非默认"
      } else if (row.status == 1) {
        return "默认"
      }
    },

    formatterShareFlag(row) {
      if (row.shareFlag == 0) {
        return "未分享"
      } else if (row.shareFlag == 1) {
        return "已分享"
      }
    },

    
    formatterDelFlag(row) {
      if (row.delFlag == 0) {
        return "未删除"
      } else if (row.delFlag == 1) {
        return "已删除"
      }
    },


       // 每页显示条数变化
      async handleSoundSizeChange(newSize) {
      this.tSize = newSize;
     
      const { data: res } = await this.$http.post("/sys/sound/record/recordList", {
        
        mobile: this.mobile,
        totalSize: this.tSize,
        currPage: this.cPage,
      });
      
      if (res.code != "000000") {
        this.$message.error("测量信息请求失败");
      } else {
        
        this.soundRecordData = res.data.records;
        this.totalNumber = res.data.total;

      }

    },
    // 当前页变化
   async handleSoundCurrentChange(newPage) {
      this.cPage = newPage;
   
      const { data: res } = await this.$http.post("/sys/sound/record/recordList", {
        
        mobile: this.mobile,
        totalSize: this.tSize,
        currPage: this.cPage,
      });
      
      if (res.code != "000000") {
        this.$message.error("测量信息请求失败");
      } else {
        
        this.soundRecordData = res.data.records;
        this.totalNumber = res.data.total;

      }

    },


    // 表格选中数据
    handleSelectionChange(val) {
      this.checkUserid = val.map((item) => {
        return item.id;
      });
    },
  },
};
</script>
<style lang="less" scoped>

</style>
